import { client } from "./_base";

export type Class = {
  id: number;
  code: string;
  description: string;
  active: number;
};

export const classes = client<Class>("class", (item) => ({
  ...item,
}));

export const classesAllSortedMappedforCombo = async () => {
  const result = await classes.all().then((data) => {
    return data
      .filter((item) => item.active)
      .sort((a, b) => {
        if (Number(a.code) > Number(b.code)) return 1;
        if (Number(a.code) < Number(b.code)) return -1;
        return 1;
      })
      .map((item) => {
        return { id: item.id, value: `${item.code}` };
      });
  });
  return result;
};

export const getActiveClasses = async () => {
  const result = await classes.all();
  return result.filter((row) => row.active);
};
